/**
 * feed-position-and-pause — the next step of a landing on a card
 * (`landOnRecoId`: a remembered circle position, a tap in My Recos, a
 * notification), which pages the feed until the card is mounted.
 *
 * It gave up whenever `hasNextPage` was falsy — which is also the state BEFORE
 * THE FIRST PAGE ARRIVES on a circle not cached yet: the landing was dropped
 * exactly when it had to wait. Pure so the rule is testable without the deck.
 */
export type LandingStep = 'land' | 'wait' | 'fetch' | 'give-up';

export function landingStep({
  found,
  loaded,
  failed,
  hasNextPage,
  isFetching,
}: {
  /** The target card is mounted in the deck. */
  found: boolean;
  /** At least one page of THIS feed has arrived. */
  loaded: boolean;
  /** The feed (or its next page) failed: waiting or refetching would never end. */
  failed: boolean;
  hasNextPage: boolean | undefined;
  isFetching: boolean;
}): LandingStep {
  if (found) return 'land';
  // Any failure ends the landing — with pages already loaded too: a failed
  // next page keeps `hasNextPage` true, and 'fetch' would loop on the error.
  if (failed) return 'give-up';
  if (!loaded) return 'wait';
  if (hasNextPage) return isFetching ? 'wait' : 'fetch';
  return 'give-up';
}
